import { useCallback, useState } from 'react';
// TODO: Replace with real implementation when API is ready
export function useSendRetireNotificationEmail() {
  const [loading, setLoading] = useState(false);

  const sendEmail = useCallback(async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setLoading(false);
  }, []);

  return [sendEmail, { loading }] as const;
}
